import { render, staticRenderFns } from "./boardTwoItem.vue?vue&type=template&id=069b630e&scoped=true"
import script from "./boardTwoItem.vue?vue&type=script&lang=js"
export * from "./boardTwoItem.vue?vue&type=script&lang=js"
import style0 from "./boardTwoItem.vue?vue&type=style&index=0&id=069b630e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069b630e",
  null
  
)

export default component.exports